/**
 * Smallpdf—Edit, Convert, Compress, & AI Summarize PDF
 *
 * PDF tool exposing its iframe host page to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker for this extension, so detection falls back to resource probing.
 * Manifest verified against version 0.23.21.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'ohfgljdgelakfkefopgklcohadegdpjf';
export const smallpdf: ExtensionDefinition = {
  id: ID,
  name: "Smallpdf—Edit, Convert, Compress, & AI Summarize PDF",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 2000000,
  notes: "PDF tool exposing its iframe host page to every origin.",
  signals: [
    { id: 'war-iframe-html', kind: 'web-accessible-resource',
      description: 'Fetch iframe.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'iframe.html') },
    { id: 'war-handle-auth-html', kind: 'web-accessible-resource',
      description: 'Fetch handle-auth.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'handle-auth.html') },
  ],
};
